import { DialogType } from '@tableau/widgets';
import * as React from 'react';
import { AddActiveDirectoryServerUsersDialog } from '../../app/users/AddActiveDirectoryServerUsersDialog';
import { AddActiveDirectorySiteUsersDialog } from '../../app/users/AddActiveDirectorySiteUsersDialog';
import { AddActiveDirectoryServerUsersDialogCtrl } from '../controllers/AddActiveDirectoryServerUsersDialogCtrl';
import { AddActiveDirectorySiteUsersDialogCtrl } from '../controllers/AddActiveDirectorySiteUsersDialogCtrl';
import { AngularContextFactory } from '../factories/AngularContextFactory';
import { FeatureFlags } from '../FeatureFlags';
import { Module } from '../Module';
import { SiteUsers } from '../resources/SiteUsers';
import { UserAddedEvent } from './AddUsersOptionsAction';
import { ModalService, ModalSize } from './ModalService';
import { ModalInstance, ReactModalService } from './ReactModalService';

const serverAndSiteUsersDialogStyle: React.CSSProperties = {
  width: 'auto',
  height: 'auto',
  paddingTop: '18px',
  paddingBottom: '12px',
  paddingLeft: '12px',
  paddingRight: '12px'
};

export class AddActiveDirectoryUsersAction {

  public static $inject = [
    'ModalService',
    'SiteUsers',
    'AngularContextFactory',
  ];

  constructor(
    private modal: ModalService,
    private siteUsers: SiteUsers,
    private angularContextFactory: AngularContextFactory,
  ) { }

  public showAddActiveDirectoryUsersToSiteDialog(dialogScope: ng.IScope, availableQuota: number): ng.IPromise<any> {

    if (FeatureFlags.addActiveDirectorySiteUsersDialogReactEnabled) {
      let modalInstance: ModalInstance;
      const dialogProps = {
        dismiss: () => modalInstance && modalInstance.dismiss(),
        close: (result: any) => modalInstance && modalInstance.close(result),
        emitUserAddedEvent: () => dialogScope.$emit(UserAddedEvent),
        angularContext: this.angularContextFactory.create(dialogScope),
        availableQuota: availableQuota
      };

      modalInstance = ReactModalService.open({
        type: DialogType.Uber,
        dialogContent: React.createElement(AddActiveDirectorySiteUsersDialog, dialogProps),
        testId: 'addActiveDirectorySiteUsersDialog',
        showCloseButton: true,
        dialogStyle: serverAndSiteUsersDialogStyle,
        shouldNotSetDefaultWidth: true
      });

      return modalInstance.result;
    }

    const dialogInstance = this.modal.open({
      scope: dialogScope, // needed so that scope events can go through
      templateUrl: 'addActiveDirectorySiteUsersDialog.html',
      size: ModalSize.fitToContent,
      controller: AddActiveDirectorySiteUsersDialogCtrl,
      resolve: {
        availableQuota: () => this.siteUsers.getRemainingUserQuota()
      }
    });

    return dialogInstance.result;
  }

  public showAddActiveDirectoryUsersToServerDialog(
    dialogScope: ng.IScope): ng.IPromise<any> {

    if (FeatureFlags.addActiveDirectoryServerUsersDialogReactEnabled) {
      let modalInstance: ModalInstance;
      const dialogProps = {
        dismiss: () => modalInstance && modalInstance.dismiss(),
        close: (result: any) => modalInstance && modalInstance.close(result),
        emitUserAddedEvent: () => dialogScope.$emit(UserAddedEvent),
        angularContext: this.angularContextFactory.create(dialogScope)
      };

      modalInstance = ReactModalService.open({
        type: DialogType.Uber,
        dialogContent: React.createElement(AddActiveDirectoryServerUsersDialog, dialogProps),
        testId: 'addActiveDirectoryServerUsersDialog',
        showCloseButton: true,
        dialogStyle: serverAndSiteUsersDialogStyle,
        shouldNotSetDefaultWidth: true
      });

      return modalInstance.result;
    }

    const dialogInstance = this.modal.open({
      scope: dialogScope, // needed so that scope events can go through
      templateUrl: 'addActiveDirectoryServerUsersDialog.html',
      size: ModalSize.fitToContent,
      controller: AddActiveDirectoryServerUsersDialogCtrl
    });

    return dialogInstance.result;
  }

}

Module.instance().service('AddActiveDirectoryUsersAction', AddActiveDirectoryUsersAction);
